export default `
  query GetJiraIssues2($projectId: ID!, $workflowId: ID!, $apiToken: String!) {
    getJiraIssues2(projectId: $projectId, workflowId: $workflowId, apiToken: $apiToken) {
      requirementId
      jiraIssue
    }
  }
`
